import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Programs from './components/Programs';
import Cases from './components/Cases';
import Partners from './components/Partners';
import UniversityExperience from './components/UniversityExperience';
import Statistics from './components/Statistics';
import CorporateTraining from './components/CorporateTraining';
import Hackathons from './components/Hackathons';
import KEGOC from './components/KEGOC';
import Banner from './components/Banner';
import Form from './components/Form';
import Footer from './components/Footer';
import ScrollProgress from './components/ScrollProgress';
import ParticlesBackground from './components/ParticlesBackground';

function App() {
  return (
    <div className="App">
      <ParticlesBackground />
      <ScrollProgress />
      <Header />
      <Hero />
      <About />
      <Programs />
      <Cases />
      <Partners />
      <UniversityExperience />
      <Statistics />
      <CorporateTraining />
      <Hackathons />
      <KEGOC />
      <Banner />
      <Form />
      <Footer />
    </div>
  );
}

export default App;

